/**
 * Screenshot reader™
 *
 * Texthelp OCR reader; exposes its OCR page to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 2.0.14.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'enfolipbjmnmleonhhebhalojdpcpdoo';
export const screenshotReader: ExtensionDefinition = {
  id: ID,
  name: "Screenshot reader™",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Texthelp OCR reader; exposes its OCR page to every origin.",
  signals: [
    { id: 'war-pages-ocr-html', kind: 'web-accessible-resource',
      description: 'Fetch pages/ocr.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'pages/ocr.html') },
    { id: 'war-scripts-main-js', kind: 'web-accessible-resource',
      description: 'Fetch scripts/main.js, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'scripts/main.js') },
  ],
};
